export default () => ({
  componentName: 'cell-percent',
});
